/**
 * Oberflächen-Kennungen der Plattform.
 *
 * Die kanonische Registry liegt in der employee-api (`employee_config.frontends`,
 * Migration 003) und ist mandantenübergreifend — dieselben Mandanten, verschiedene
 * Oberflächen. Diese Konstante ist bewusst nur eine Kopie der Codes, KEINE zweite
 * Wahrheitsquelle: Sie dient dem Normalisieren beim Schreiben.
 *
 * Warum nicht live abfragen: Ein Fehler-Melder oder ein Kopfleisten-Chip darf nicht
 * daran hängen, dass die employee-api gerade erreichbar ist. Sonst verhindert genau
 * deren Ausfall die Meldung, mit der jemand den Ausfall meldet. Auswahllisten in
 * Verwaltungsmasken dürfen dagegen live lesen — dort wäre eine veraltete Liste
 * sichtbar falsch.
 *
 * Kommt eine Oberfläche dazu, gehört ihr Code HIER hinein.
 */
export const FRONTEND_CODES = ['SMS-PRO', 'PHQ'];
/** Vorgabe für Aufrufer, die keine Kennung mitschicken (Bestandsclients). */
export const DEFAULT_FRONTEND_CODE = 'SMS-PRO';
/**
 * Schreibweisen, die auf einen kanonischen Code abgebildet werden. Ohne diese
 * Toleranz stünde derselbe Gegenstand unter zwei Kennungen in den Daten — genau
 * das war beim Fehler-Melder bereits passiert (`projecthq` statt `PHQ`).
 */
const ALIASES = {
    'sms-pro': 'SMS-PRO',
    smspro: 'SMS-PRO',
    sms_pro: 'SMS-PRO',
    phq: 'PHQ',
    projecthq: 'PHQ',
    'project-hq': 'PHQ',
    project_hq: 'PHQ',
};
/**
 * Bildet eine beliebige Eingabe auf einen kanonischen Oberflächen-Code ab.
 * Unbekanntes fällt auf die Vorgabe — eine Meldung geht nie wegen einer
 * unbekannten Kennung verloren.
 */
export function normalizeFrontendCode(raw) {
    if (typeof raw !== 'string')
        return DEFAULT_FRONTEND_CODE;
    const key = raw.trim().toLowerCase();
    if (!key)
        return DEFAULT_FRONTEND_CODE;
    const exact = FRONTEND_CODES.find((c) => c.toLowerCase() === key);
    return exact ?? ALIASES[key] ?? DEFAULT_FRONTEND_CODE;
}
/** Anzeigenamen der Oberflächen (Registry-Feld `name`), für Auswahlmasken. */
export const FRONTEND_LABELS = {
    'SMS-PRO': 'SMS PRO',
    PHQ: 'ProjectHQ',
};
/**
 * Strenge Variante: liefert null statt einer Vorgabe, wenn die Eingabe kein
 * bekannter Code ist.
 *
 * Zu verwenden überall dort, wo die Kennung eine WIRKUNG hat statt nur ein
 * Merkmal zu sein — bei den Kopfleisten-Chips etwa steuert sie, in welcher
 * Oberfläche ein Hinweis erscheint. Ein Tippfehler würde dort still auf die
 * Vorgabe fallen und den Hinweis im falschen Produkt anzeigen, also genau das
 * auslösen, was das Feld verhindern soll. Beim Schreiben ist ein Fehler die
 * sichere Wahl: die Verwaltungsmaske kennt die gültigen Werte, etwas Unbekanntes
 * kann dort nur ein Fehler sein. (Hinweis employee-api, 2026-08-10.)
 */
export function parseFrontendCode(raw) {
    if (typeof raw !== 'string')
        return null;
    const key = raw.trim().toLowerCase();
    if (!key)
        return null;
    const exact = FRONTEND_CODES.find((c) => c.toLowerCase() === key);
    return exact ?? ALIASES[key] ?? null;
}
//# sourceMappingURL=frontends.js.map